import { Check } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";

const STEPS = [
  { label: "Profile", route: "/profile", test: (p: string) => p.startsWith("/profile") },
  { label: "Intake", route: "/intake", test: (p: string) => p.startsWith("/intake") || p.startsWith("/publications") },
  { label: "Evidence", route: "/", test: (p: string) => /^\/applications\/./.test(p) },
  { label: "Recommenders", route: "/recommenders", test: (p: string) => p.startsWith("/recommenders") },
  { label: "Review", route: "/engagements", test: (p: string) => p.startsWith("/engagements") || p.startsWith("/marketplace") },
];

function activeIndex(pathname: string): number {
  for (let i = 0; i < STEPS.length; i++) {
    if (STEPS[i].test(pathname)) return i;
  }
  return -1;
}

export function OnboardingProgress() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const idx = activeIndex(pathname);
  if (idx === -1) return null;

  return (
    <div className="sticky top-0 z-10 border-b border-slate-200 bg-white/95 backdrop-blur-sm px-6 py-2.5">
      <nav aria-label="Petition progress">
        <ol className="flex items-center">
          {STEPS.map((step, i) => {
            const done = i < idx;
            const current = i === idx;
            return (
              <li key={step.label} className="flex items-center">
                <button
                  type="button"
                  onClick={() => navigate(step.route)}
                  className="group flex items-center gap-1.5"
                  aria-current={current ? "step" : undefined}
                >
                  <span
                    className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full transition-colors ${
                      done
                        ? "bg-emerald-500 text-white"
                        : current
                          ? "bg-blue-600 text-white"
                          : "border border-slate-300 text-slate-400 group-hover:border-slate-400"
                    }`}
                  >
                    {done ? (
                      <Check className="h-3 w-3" />
                    ) : (
                      <span className="text-[10px] font-bold">{i + 1}</span>
                    )}
                  </span>
                  <span
                    className={`text-xs font-medium transition-colors ${
                      current
                        ? "text-blue-600"
                        : done
                          ? "text-emerald-700"
                          : "text-slate-400 group-hover:text-slate-600"
                    }`}
                  >
                    {step.label}
                  </span>
                </button>
                {i < STEPS.length - 1 && (
                  <div
                    className={`mx-3 h-px w-8 flex-shrink-0 ${done ? "bg-emerald-300" : "bg-slate-200"}`}
                  />
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </div>
  );
}
